import axios from '../utils/axios';

export const calculatePrediction = (id) => {
  return axios.get(`projects/calculatePrediction/${id}`).then(response => response.data);
}
export const publishOngeoserver = (data) => {
    // {
    //     areaId: id,
    //     workspace: "forest",
    //     epsg: 5514,
    //     cameraType: "RGB"
    // }
    return axios.post(`geoprocessing/PublishOnGeoserver`,data).then(response => response.data);
  }